import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconMoreVertical = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <path
          d="M12.2917 15.8333C12.2917 17.1 11.2667 18.125 10 18.125C8.73334 18.125 7.70834 17.1 7.70834 15.8333C7.70834 14.5667 8.73334 13.5417 10 13.5417C11.2667 13.5417 12.2917 14.5667 12.2917 15.8333Z"
          fill={color}
        />
        <path
          d="M12.2917 4.16667C12.2917 5.43333 11.2667 6.45833 10 6.45833C8.73334 6.45833 7.70834 5.43333 7.70834 4.16667C7.70834 2.9 8.73334 1.875 10 1.875C11.2667 1.875 12.2917 2.9 12.2917 4.16667Z"
          fill={color}
        />
        <path
          d="M12.2917 10C12.2917 11.2667 11.2667 12.2917 10 12.2917C8.73334 12.2917 7.70834 11.2667 7.70834 10C7.70834 8.73333 8.73334 7.70833 10 7.70833C11.2667 7.70833 12.2917 8.73333 12.2917 10Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
